import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./ProfileInformation.module.sass";
import Item from "../Item";
import TextInput from "../../../components/TextInput";
import { updateCurrentUser } from "../../../services/account.service";
import { showSuccess, showError } from "../../../services/toast.service";

const ProfileInformation = ({ className, userData, loading, formData, onFormChange }) => {
  const [localFormData, setLocalFormData] = useState({
    name: '',
    email: ''
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (userData && userData.user) {
      setLocalFormData({
        name: formData?.name || userData.user.name || '',
        email: userData.user.email || ''
      });
    }
  }, [userData, formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedFormData = {
      ...localFormData,
      [name]: value
    };
    setLocalFormData(updatedFormData);
    onFormChange && onFormChange(updatedFormData);
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();

    if (!localFormData.name.trim()) {
      showError('Le nom et prénom sont obligatoires.');
      return;
    }
    if (localFormData.name.trim().length > 100) {
      showError('Le nom et prénom ne doivent pas dépasser 100 caractères.');
      return;
    }

    setIsSaving(true);

    try {
      await updateCurrentUser({
        name: localFormData.name.trim(),
      });

      showSuccess('Informations du profil mises à jour avec succès !');
    } catch (error) {
      console.error('Erreur lors de la mise à jour des informations du profil:', error);
      showError(error.message || 'Une erreur est survenue lors de la mise à jour du profil.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Item
      className={cn(styles.card, className)}
      title="Informations du profil"
      classTitle="title-green"
    >
      {loading ? (
        <div className={styles.loading}>Chargement des informations...</div>
      ) : (
        <form className={styles.fieldset} onSubmit={handleSaveProfile}>
          <TextInput
            className={styles.field}
            label="Nom prénom"
            name="name"
            type="text"
            value={localFormData.name}
            onChange={handleChange}
            tooltip="Maximum 100 caractères"
            required
          />
          <TextInput
            className={styles.field}
            label="Email"
            name="email"
            type="email"
            value={localFormData.email}
            onChange={handleChange}
            tooltip="Adresse email valide"
            required
            disabled
          />
          <button
            className={cn("button-stroke", styles.button)}
            type="submit"
            disabled={isSaving}
          >
            {isSaving ? "Enregistrement..." : "Enregistrer les modifications"}
          </button>
        </form>
      )}
    </Item>
  );
};

export default ProfileInformation;